class Menu {
  burger: Element | null;
  menu: Element | null;
  overlay: Element | null;
  constructor() {
    this.burger = document.querySelector('button[data-trigger="header-primary"]');
    this.menu = document.querySelector('div[data-trigger="menu"]');
    this.overlay = document.querySelector('div[data-trigger="overlay"]');
    if(this.burger){
      this._init();
    }
  }

  _init() {
    this.burger!.addEventListener('click', () => {
      if(this.burger?.getAttribute('data-state') == 'open'){
        this.burger?.setAttribute('data-state', 'close');
        this.menu?.classList.remove('active');
        this.overlay?.classList.remove('active');
      }else{
        this.burger?.setAttribute('data-state', 'open');
        this.menu?.classList.add('active');
        this.overlay?.classList.add('active');
      }
    });

    this.overlay?.addEventListener('click', () => {
      this.burger?.setAttribute('data-state', 'close');
      this.menu?.classList.remove('active');
      this.overlay?.classList.remove('active');
    });
  }
}
export const menu = new Menu();
